import React, { PureComponent, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import Gettext from "../common/Gettext";
import { gaReducer } from "../GA";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.61);
  z-index: 99999;
`;

const Container = styled.div`
  position: relative;
  width: 87%;
  max-width: 320px;
  padding: 21px 21px 16px 21px;
  border-radius: 3px;
  background-color: #fff;
`;

const Title = styled.div`
  margin-bottom: 21px;
  font-size: 16px;
  font-weight: bold;
  color: #222;

  ${({ centred }) =>
    centred &&
    css`
      margin-top: 17px;
      text-align: center;
    `};
`;

const Text = styled.div`
  font-size: 14px;
  color: #000;
  line-height: 19px;
`;

const Button = styled.div`
  padding: 5px 10px;
  font-size: 14px;
  line-height: 1.2;
  font-weight: bold;
  color: #3b9478;
  text-transform: uppercase;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.45;
      pointer-events: none;
    `};
`;

const StarsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 226px;
  margin: 20px auto 28px auto;
`;

const Input = styled.input`
  ~ label {
    color: #ccc;
  }

  :checked ~ label {
    color: #ffcc00;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Success = styled.div`
  position: absolute;
  left: 50%;
  top: -26px;
  width: 46px;
  height: 46px;
  margin-left: -23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  border-radius: 50%;
  background-color: #3b9478;
`;

const Star = ({ value, rate, setRate }) => (
  <React.Fragment>
    <Input
      type="radio"
      id={`id-${value}`}
      value={value}
      name="rating"
      style={{ display: "none" }}
      defaultChecked={value === rate}
    />
    <label
      htmlFor={`id-${value}`}
      onClick={() => {
        setRate && setRate(value);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <path
          d="M15,0l4.688,9.605L30,11.142l-7.5,7.492L24.187,29.2,15,24.206,5.812,29.2,7.5,18.634,0,11.142,10.313,9.605Z"
          fill="currentColor"
        />
        <rect width="30" height="30" fill="none" />
      </svg>
    </label>
  </React.Fragment>
);

export const RatePopup = ({ onHide, clearTimer = () => void 0}, resetCounter) => {
  const [rate, setRate] = useState(null);
  const [successPopup, setSuccessPopup] = useState(null);
  const [error, store] = localStorage();
  useEffect(() => gaReducer("SHOW_RATE_APP_POPUP"), []);
  if (error) return null;

  const later = () => {
    gaReducer("LATER_APP_RATING");
    const rateLater = store.get(RATE_LATER);
    if (rateLater) {
      store.set(RATE_LATER, "never");
      clearTimer();
      onHide();
      return;
    }
    store.set(RATE_LATER, Date.now());
    store.set(KEY_DEALS_COUNT, resetCounter ? 0 : COUNT);
    onHide();
  };

  if (successPopup) {
    return (
      <Overlay
        onClick={() => {
          setSuccessPopup(null);
          clearTimer();
          onHide();
        }}
      >
        <Container>
          <Success>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.216"
              height="15.072"
              viewBox="0 0 20.216 15.072"
            >
              <g transform="translate(0 -5.814)">
                <g transform="translate(0 5.814)">
                  <path
                    d="M9.151,20.2a2.348,2.348,0,0,1-3.32,0L.687,15.055a2.347,2.347,0,1,1,3.32-3.319L7.072,14.8a.594.594,0,0,0,.839,0l8.3-8.3a2.347,2.347,0,1,1,3.32,3.319Z"
                    transform="translate(0 -5.814)"
                    fill="#fff"
                  />
                </g>
              </g>
            </svg>
          </Success>
          <Title centred={true}>
            {rate > 3 ? (
              <Gettext>Thank you for your feedback!</Gettext>
            ) : (
              <Gettext>Thank you!</Gettext>
            )}
          </Title>
          <StarsContainer>
            <Star value={5} rate={successPopup} />
            <Star value={4} rate={successPopup} />
            <Star value={3} rate={successPopup} />
            <Star value={2} rate={successPopup} />
            <Star value={1} rate={successPopup} />
          </StarsContainer>
        </Container>
      </Overlay>
    );
  }

  return (
    <Overlay>
      <Container>
        <Title>
          <Gettext>Rate IronTrade app</Gettext>
        </Title>
        <Text>
          <Gettext>
            If you enjoy using Iron Trade app, please take a moment to rate it!
          </Gettext>
        </Text>
        {/* Из-за особенностей работы css-селекторов рейтинга,
        звёзды располагаем в обратном порядке */}
        <StarsContainer>
          <Star value={5} setRate={setRate} />
          <Star value={4} setRate={setRate} />
          <Star value={3} setRate={setRate} />
          <Star value={2} setRate={setRate} />
          <Star value={1} setRate={setRate} />
        </StarsContainer>
        <ButtonsContainer>
          <Button onClick={later}>
            <Gettext>Later</Gettext>
          </Button>
          <Button
            disabled={rate == null}
            onClick={() => {
              if (rate > 3) {
                gaReducer("SET_POSITIVE_APP_RATING", {
                  rate
                });
                try {
                  window.nativeInterface &&
                  window.nativeInterface.redirectToMarket();
                  setTimeout(() => setSuccessPopup(rate), 2000);
                } catch (e) {
                  setSuccessPopup(rate);
                  gaReducer("RATE_APP_ERROR", {
                    error: e.message
                  })
                }
              } else {
                gaReducer("SET_NEGATIVE_APP_RATING", {
                  rate
                });
                setSuccessPopup(rate);
              }
              setRate(null);
              store.set(RATE_LATER, "never");
            }}
          >
            <Gettext>Submit</Gettext>
          </Button>
        </ButtonsContainer>
      </Container>
    </Overlay>
  );
};

const KEY_DEALS_COUNT = "__it_dealscount";
const COUNT = 1;
const RATE_LATER = "rate_later";
// повторно показать попап не ранее чем через сутки
const SHOW_AFTER = 8640000;

const localStorage = () => {
  const store = {};
  try {
    store.set = (key, value) => window.localStorage.setItem(key, value);
    store.get = (key = KEY_DEALS_COUNT) => window.localStorage.getItem(key);
    store.rm = (key = KEY_DEALS_COUNT) => window.localStorage.removeItem(key);
    return [null, store];
  } catch (ex) {
    return [ex];
  }
};

localStorage.keys = { KEY_DEALS_COUNT }; // словарь ключей, которые пишет эта ф-я в localStorage

localStorage.flush = () => {
  //очистка всех ключей которые может юзать эта ф-я
  Object.keys(localStorage.keys).forEach(k => {
    const [error, store] = localStorage();
    if (error) {
      console.log(error);
      return;
    }
    store.rm(k);
  });
};

class Rate extends PureComponent {
  ls = localStorage();
  state = {
    isReadyForPopup: false,
    error: null
  };
  componentDidMount() {
    const [error, store] = this.ls;
    if (error) {
      return this.setState({ error });
    }
    const rateLater = store.get(RATE_LATER);
    const dealsCount = store.get(KEY_DEALS_COUNT);
    if (rateLater === "never" && dealsCount === "WASTED") {
      return null;
    }
    //Таймер смотрит каждые полсекунды на кол-во сделок успешных, как только их стало COUNT, он запускает интервал на 10 сек и сам обнуляется
    //по истечении интервала выскакивает попап с рейтингом
    this.timer = window.setInterval(() => {
      const rateLater = store.get(RATE_LATER);
      const dealsCount = store.get(KEY_DEALS_COUNT);

      if (
        dealsCount !== "WASTED" &&
        Number(dealsCount) >= Number(COUNT) &&
        (!rateLater ||
          (rateLater &&
            rateLater !== "never" &&
            Number(rateLater) + SHOW_AFTER < Date.now()))
      ) {
        store.set(KEY_DEALS_COUNT, "WASTED");
        this.timeout = window.setTimeout(() => {
          this.setState({ isReadyForPopup: true }, () => {
            window.clearInterval(this.timeout);
          });
        }, 10000);
      }
    }, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.timer);
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  render() {
    const { error, isReadyForPopup } = this.state;
    if (error) {
      console.log(error);
      return null;
    }
    return isReadyForPopup && process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? (
      <RatePopup
        clearTimer={() => window.clearInterval(this.timer)}
        onHide={() => this.setState({ isReadyForPopup: false })}
      />
    ) : null;
  }
}

export { Rate, localStorage };



// WEBPACK FOOTER //
// ./src/components/webview/Rate.js